import { render, staticRenderFns } from "./DownloadButton.vue?vue&type=template&id=8c53bf32&scoped=true&"
import script from "./DownloadButton.vue?vue&type=script&lang=js&"
export * from "./DownloadButton.vue?vue&type=script&lang=js&"
import style0 from "./DownloadButton.vue?vue&type=style&index=0&id=8c53bf32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c53bf32",
  null
  
)

export default component.exports